// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://celoscan.io/address/0x0826492a24b1dBd1d8fcB4701b38C557CE685e9D
export const KES__USD = '0x0826492a24b1dBd1d8fcB4701b38C557CE685e9D';

// https://celoscan.io/address/0xe38A27BE4E7d866327e09736F3C570F256FFd048
export const CUSD__USD = '0xe38A27BE4E7d866327e09736F3C570F256FFd048';

// https://celoscan.io/address/0xe8EcaF727080968Ed5F6DBB595B91e50eEb9F8B3
export const BRL__USD = '0xe8EcaF727080968Ed5F6DBB595B91e50eEb9F8B3';

// https://celoscan.io/address/0x5e37AF40A7A344ec9b03CCD34a250F3dA9a20B02
export const USDT__USD = '0x5e37AF40A7A344ec9b03CCD34a250F3dA9a20B02';

// https://celoscan.io/address/0x6b6a4c71ec3858A024f3f0Ee44bb0AdcBEd3DcC2
export const LINK__USD = '0x6b6a4c71ec3858A024f3f0Ee44bb0AdcBEd3DcC2';

// https://celoscan.io/address/0x1FcD30A73D67639c1cD89ff5746E7585731c083B
export const ETH__USD = '0x1FcD30A73D67639c1cD89ff5746E7585731c083B';

// https://celoscan.io/address/0x0568fD19986748cEfF3301e55c0eb1E729E0Ab7e
export const CELO__USD = '0x0568fD19986748cEfF3301e55c0eb1E729E0Ab7e';

// https://celoscan.io/address/0xe76FE54dfeD2ce8B4d1AC63c982DfF7CFc92bf82
export const GBP__USD = '0xe76FE54dfeD2ce8B4d1AC63c982DfF7CFc92bf82';

// https://celoscan.io/address/0xc7A353BaE210aed958a1A2928b654938EC59DaB2
export const USDC__USD = '0xc7A353BaE210aed958a1A2928b654938EC59DaB2';

// https://celoscan.io/address/0xf323563241BF8B77a2979e9edC1181788A98EcB2
export const JPY__USD = '0xf323563241BF8B77a2979e9edC1181788A98EcB2';

// https://celoscan.io/address/0x04cE1b865a45cAF8e5218114C9DD03540753C68a
export const KRW__USD = '0x04cE1b865a45cAF8e5218114C9DD03540753C68a';

// https://celoscan.io/address/0x2f6d6cB9e01d63e1a1873BACc5BfD4e7d4e461d1
export const CAD__USD = '0x2f6d6cB9e01d63e1a1873BACc5BfD4e7d4e461d1';

// https://celoscan.io/address/0xf2Bd4FAa89f5A360cDf118bccD183307fDBcB6F5
export const AUD__USD = '0xf2Bd4FAa89f5A360cDf118bccD183307fDBcB6F5';

// https://celoscan.io/address/0x2719B648DB57C5601Bd4cB2ea934Dec6F4262cD8
export const GHS__USD = '0x2719B648DB57C5601Bd4cB2ea934Dec6F4262cD8';

// https://celoscan.io/address/0xfd49bFcb3dc4aAa713c25e7d23B14BB39C4B8857
export const CHF__USD = '0xfd49bFcb3dc4aAa713c25e7d23B14BB39C4B8857';

// https://celoscan.io/address/0x3D207061Dbe8E2473527611BFecB87Ff12b28dDa
export const EUR__USD = '0x3D207061Dbe8E2473527611BFecB87Ff12b28dDa';

// https://celoscan.io/address/0x97b770B0200CCe161907a9cbe0C6B177679f8F7C
export const COP__USD = '0x97b770B0200CCe161907a9cbe0C6B177679f8F7C';

// https://celoscan.io/address/0x128fE88eaa22bFFb868Bb3A584A54C96eE24014b
export const BTC__USD = '0x128fE88eaa22bFFb868Bb3A584A54C96eE24014b';

// https://celoscan.io/address/0x235e5c8697177931459fA7D19fba7256d29F17DA
export const NGN__USD = '0x235e5c8697177931459fA7D19fba7256d29F17DA';

// https://celoscan.io/address/0x11b7221a0DD025778A95e9E0B87b477522C32E02
export const ZAR__USD = '0x11b7221a0DD025778A95e9E0B87b477522C32E02';

// https://celoscan.io/address/0x17B1DD4888E8509C5404768E6004819c82916097
export const STCELO__CELO_Exchange_Rate = '0x17B1DD4888E8509C5404768E6004819c82916097';

// https://celoscan.io/address/0x85d4Ec34339478F73c153710B19f2D5C402dce6F
export const INR__USD = '0x85d4Ec34339478F73c153710B19f2D5C402dce6F';

// https://celoscan.io/address/0x91b21900E91CD302EBeD05E45D8f270ddAED944d
export const AAVE_Network_Emergency_Count_Celo = '0x91b21900E91CD302EBeD05E45D8f270ddAED944d';

// https://celoscan.io/address/0x4ce8e628Bb82Ea5271908816a6C580A71233a66c
export const PHP__USD = '0x4ce8e628Bb82Ea5271908816a6C580A71233a66c';

// https://celoscan.io/address/0x1626095f9548291cA67A6Aa743c30A1BB9380c9d
export const XOF__USD = '0x1626095f9548291cA67A6Aa743c30A1BB9380c9d';

// https://celoscan.io/address/0xBa45f0a1a2fa3FB62a4D6dC135741E2aeb1b14e7
export const LINK__CELO = '0xBa45f0a1a2fa3FB62a4D6dC135741E2aeb1b14e7';

// https://celoscan.io/address/0x9a48d9b0AF457eF040281A9Af3867bc65522Fecd
export const EURC__USD = '0x9a48d9b0AF457eF040281A9Af3867bc65522Fecd';

export const CHAIN_ID = 42220;
